
<div class="c-client-search__header">
  <h3 class="t3 c-client-search__header-title">Surf Banner</h3>
</div>
<div class="product-management">
  <form [formGroup]="productForm" (ngSubmit)="onSubmit()" class="product-form">
    <div>
      <label>Product Code:</label>
      <input formControlName="product_code" />
    </div>
    <div>
      <label>Image URL:</label>
      <input formControlName="image_url" />
    </div>
    <div>
      <label>Title:</label>
      <input formControlName="title" />
    </div>
    <div>
      <label>Search Param:</label>
      <input formControlName="search_param" />
    </div>
    <div>
      <label>Publish Start Date:</label>
      <input type="date" formControlName="publish_start_date" />
    </div>
    <div>
      <label>Publish End Date:</label>
      <input type="date" formControlName="publish_end_date" />
    </div>
    <div>
      <label>Active:</label>
      <input type="checkbox" formControlName="active" />
    </div>
    <div>
      <button type="submit" [disabled]="productForm.invalid">{{ editIndex !== null ? 'Update' : 'Add' }} Product</button>
      <button type="button" *ngIf="editIndex !== null" (click)="onCancelEdit()">Cancel</button>
    </div>
  </form>

  <h3>Existing Products</h3>
<!--  <div class="table-responsive">
    <table border="1">
      <thead>
      <tr>
        <th>Product Code</th>
        <th>Image</th>
        <th>Title</th>
        <th>Edit</th>
        <th>Delete</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let p of products; let i = index">
        <td>{{ p.product_code }}</td>
        <td><img [src]="p.image_url" alt="img" width="50" /></td>
        <td>{{ p.title }}</td>
&lt;!&ndash;        <td><button (click)="onEdit(i)">Edit</button></td>
        <td><button class="delete-btn" (click)="onDelete(i)">Delete</button></td>&ndash;&gt;
        <td>
          <button (click)="onEdit(i)" title="Edit" class="icon-btn">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M14.85 2.85a1.2 1.2 0 0 1 1.7 1.7l-9.2 9.2-2.3.6.6-2.3 9.2-9.2zM3 17h14v2H3v-2z" fill="#1976d2"/>
            </svg>
          </button>
        </td>
        <td>
          <button (click)="onDelete(i)" title="Delete" class="icon-btn delete-btn">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M6 7v7h2V7H6zm3 0v7h2V7h-2zm3 0v7h2V7h-2zM5 4V2h10v2h5v2H0V4h5zm2 0h6V2H7v2z" fill="#e53935"/>
            </svg>
          </button>
        </td>

      </tr>
      <tr *ngIf="products.length === 0">
        <td colspan="8">No products found.</td>
      </tr>
      </tbody>
    </table>
  </div>-->
  <div class="table-responsive">
    <table border="1">
      <thead>
      <tr>
        <th>Product Code</th>
        <th>Image</th>
        <th>Title</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let p of products; let i = index">
        <td>{{ p.product_code }}</td>
        <td><img [src]="p.image_url" alt="img" width="50" /></td>
        <td class="title-actions-cell">
          <span class="title-text">{{ p.title }}</span>
          <span class="actions">
            <button (click)="onEdit(i)" title="Edit" class="icon-btn">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M14.85 2.85a1.2 1.2 0 0 1 1.7 1.7l-9.2 9.2-2.3.6.6-2.3 9.2-9.2zM3 17h14v2H3v-2z" fill="#1976d2"/>
              </svg>
            </button>
            <button (click)="onDelete(i)" title="Delete" class="icon-btn delete-btn">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M6 7v7h2V7H6zm3 0v7h2V7h-2zm3 0v7h2V7h-2zM5 4V2h10v2h5v2H0V4h5zm2 0h6V2H7v2z" fill="#e53935"/>
              </svg>
            </button>
          </span>
        </td>
      </tr>
      <tr *ngIf="products.length === 0">
        <td colspan="3">No products found.</td>
      </tr>
      </tbody>
    </table>
  </div>




</div>
